import { render } from "./Cookie.vue?vue&type=template&id=1be55cfe"
import script from "./Cookie.vue?vue&type=script&lang=js"
export * from "./Cookie.vue?vue&type=script&lang=js"

import "./Cookie.vue?vue&type=style&index=0&id=1be55cfe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__